import { merge } from 'lodash';
import ReactApexChart from 'react-apexcharts';
// material
import { Typography } from '@mui/material';
//
import { BaseOptionChart } from '../../dash_charts/BaseOptionChart'

// ----------------------------------------------------------------------
var pt = require("apexcharts/dist/locales/pt.json");

const CHART_DATA = [

  {
    name: 'Tempo (min)',
    type: "area",
    data: [1, 5, 4, 6, 5, 6, 7, 8, 5, 3, 5]
  },
];

export default function DuracaoExercicio() {
  const chartOptions = merge(BaseOptionChart(), {
    chart: {
      locales: [pt],
      defaultLocale: 'pt',
    },

    stroke: { 
      width: 3,
      curve: 'smooth'
    },
    plotOptions: { 
      bar: { columnWidth: '11%', borderRadius: 4 } 
    },
    fill: { 
      type: 'gradient',
      gradient: {
        shadeIntensity: 0.3,
        opacityFrom: 0.6,
        opacityTo: 0.2,
        stops: [0, 90, 120]
      }
    },
    xaxis: { 
      type: 'datetime',
      categories: [
        '01/01/2021',
        '02/01/2021',
        '03/01/2021',
        '04/01/2021',
        '05/01/2021',
        '06/01/2021',
        '07/01/2021',
        '08/01/2021',
        '09/01/2021',
        '10/01/2021',
        '11/01/2021'
      ],
    },
    dataLabels: {
        enabled: false
      },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (y) => {
          if (typeof y !== 'undefined') {
            return `${y.toFixed(0)} `; // write something
          }
          return y;
        }
      }
    }
  });

  return (
    
    <Typography variant="h6">Tempo em Exercício
    <ReactApexChart type="line" series={CHART_DATA} options={chartOptions} height={250} />
    </Typography>
  );
}
